// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host .hideHeader {\n  display: none;\n}\n:host ion-tab-bar {\n  --background: none ;\n}\n:host .ios ion-tab-bar {\n  height: 50px;\n  padding: 0;\n  margin: 0;\n}\n:host :host-context(.plt-android) ion-tab-bar[slot=top] {\n  padding: 0;\n  margin: 0;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
